import React from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Calendar, MapPin, ArrowRight,
  CheckCircle, Clock, AlertCircle, CheckCheck
} from 'lucide-react';

const STATUS_CFG = {
  assigned: {
    color: '#8b5cf6',
    bg: 'rgba(139,92,246,0.10)',
    icon: <CheckCircle size={12} />
  },

  in_progress: {
    color: '#0491e1',
    bg: 'rgba(4,145,225,0.10)',
    icon: <Clock size={12} />
  },

  awaiting_confirmation: {
    color: '#f59e0b',
    bg: 'rgba(245,158,11,0.10)',
    icon: <AlertCircle size={12} />
  },

  completed: {
    color: '#10b981',
    bg: 'rgba(16,185,129,0.10)',
    icon: <CheckCheck size={12} />
  }
};

const ActiveJobsSection = ({ kycStatus, activeJobs }) => {
    console.log("KYC:", kycStatus);
  console.log("Jobs:", activeJobs);
  const navigate = useNavigate();

  if (!(kycStatus === "approved" && activeJobs?.length > 0)) {
    return null;
  }

  return (
    <div className="wh-section">
      <div className="wh-section__header">
        <h2 className="wh-section__title">Active Jobs</h2>
        <button className="wh-view-all" onClick={() => navigate('/bid-jobs')}>
          View All <ArrowRight size={13} />
        </button>
      </div>

      <div className="wh-jobs">
        {activeJobs.map((j, i) => {
          const st = STATUS_CFG[j.status];

          return (
            <div key={j.id} className="wh-job-card">
              <div className="wh-job-card__top">
                <span className="wh-job-card__title">
                  {j.jobTitle}
                </span>

                <span
                  className="wh-job-card__badge"
                  style={{
                    color: st?.color,
                    background: st?.bg
                  }}
                >
                  {st?.icon} {j.status}
                </span>
              </div>

              <div className="wh-job-card__meta">
                <span>
                  <Calendar size={13} />
                  {new Date(j.created_at).toLocaleDateString()}
                </span>

                <span>
                  <MapPin size={13} />
                  {j.address}
                </span>
              </div>

              <div className="wh-job-card__footer">
                <span className="wh-job-card__customer">
                  {j.whcustomer?.fullName || 'No Customer'}
                </span>

                <span className="wh-job-card__price">
                  ${j.budget}
                </span>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default ActiveJobsSection;